import React, { useEffect } from "react";
import { useSelector } from "react-redux";
// eslint-disable-next-line no-restricted-imports
import { Col } from "~/components/elements";
import { PageLayout } from "~/components/layouts/PageLayout";
import { WelcomePage } from "~/pages/dashboard/welcome-step/WelcomePage";
import { RootState } from "~/redux/root-reducer";

export default function DashboardPage() {
  const { screenIndex, step } = useSelector((state: RootState) => state.dashboard.dashboardProgress);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [screenIndex, step]);

  return (
    <Col flex={1}>
      <PageLayout
        metaTagsConfig={{
          title: `Bettershot - Dashboard`,
          description: `Get 120 professional photoshoots in 3 hours using AI. Elevate your personal brand with corporate photoshoots.`,
          charset: "utf8",
          lang: "en",
          metas: [
            {
              name: "keywords",
              content:
                "corporate photoshoot,professional photoshoot,bettershot ai,linkedin profile photo,ai photoshoot",
            },
            { name: "robots", content: "noindex,nofollow" },
          ],
          links: [{ rel: "canonical", href: window.location.href }],
        }}
        as={Col}
        flex={1}
        isInGeneratingStep
      >
        <WelcomePage />
      </PageLayout>
    </Col>
  );
}
